import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bg-white border-b border-gray-200 shadow-sm dark:bg-gray-900 lg:block dark:border-gray-800" }
const _hoisted_2 = { class: "mx-auto max-w-screen-lg" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex flex-col mt-0 w-full text-sm font-medium lg:flex-row" }
const _hoisted_5 = ["aria-current", "href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.label,
              class: "block border-b dark:border-gray-700 lg:inline lg:border-b-0"
            }, [
              _createElementVNode("a", {
                "aria-current": item.isActive ? 'page' : null,
                class: _normalizeClass([item.isActive ? 'border-b-2 text-primary-600 dark:text-primary-500 dark:border-primary-500 border-black font-bold text-black' : 'border-b-2 text-gray-500 border-white dark:border-gray-900 dark:hover:text-gray-500 dark:hover:border-gray-500 hover:border-gray-600', "block py-3 px-4 dark:text-gray-400 hover:text-primary-600"]),
                href: item.path
              }, _toDisplayString(item.label), 11, _hoisted_5)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}